/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfitdescription2Inputs */

const en_coverfitdescription2 = /** @type {(inputs: Coverfitdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI rebuilds your cover in landscape. Tell it what should stand out and it arranges the rest.`)
};

const de_coverfitdescription2 = /** @type {(inputs: Coverfitdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI baut dein Titelbild ins Querformat um. Sag ihr, was im Vordergrund stehen soll, den Rest ordnet sie selbst.`)
};

/**
* | output |
* | --- |
* | "The AI rebuilds your cover in landscape. Tell it what should stand out and it arranges the rest." |
*
* @param {Coverfitdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfitdescription2 = /** @type {((inputs?: Coverfitdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfitdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfitdescription2(inputs)
	return de_coverfitdescription2(inputs)
});
export { coverfitdescription2 as "coverFitDescription" }